/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SpoRoutingModule} from './spo-routing.module';
import {SpoMainPageModule} from './spo-main-page/spo-main-page.module';
import {SpoCreateNewModule} from './spo-create-new/spo-create-new.module';
import {SpoDetailPageModule} from './spo-detail-page/spo-detail-page.module';
import {SpoListModule} from './spo-main-page/spo-list/spo-list.module';
import {SpoEditPageModule} from './spo-edit-page/spo-edit-page.module';

@NgModule({
    imports: [
        CommonModule,
        SpoRoutingModule, SpoMainPageModule, SpoCreateNewModule, SpoDetailPageModule, SpoListModule, SpoEditPageModule
    ]
})
export class SpoModule {
}
